import {BellRegularIcon} from 'shells/icon/svg/bell-regular-icon';

export const REMINDER_OPTIONS = [
    {days: 7, label: 'Remind me to follow up every week', title: 'Follow up every week'},
    {days: 30, label: 'Remind me to follow up every month', title: 'Follow up every month'},
    {days: 90, label: 'Remind me to follow up every 3 months', title: 'Follow up every 3 months'},
] as const;

// @ts-expect-error
export const ReminderIcon = <BellRegularIcon color='black' size={20} wrapWithDiv={false} />;
